import { PayloadAction } from "@reduxjs/toolkit";
import { VideoDetailInterface } from "@/components/VideoPage/api/interface";
import { VideoState } from "@/components/VideoPage/redux/types";

const VideoReducer = {
  setVideoData: (state: VideoState, action: PayloadAction<VideoDetailInterface>) => {
    state.videoData = action.payload;
  },
  setLoading: (state: VideoState, action: PayloadAction<boolean>) => {
    state.loading = action.payload;
  },
  setDevice: (state: VideoState, action: PayloadAction<any>) => {
    state.ua = action.payload;
  },
  setError: (state: VideoState, action: PayloadAction<any>) => {
    state.error = action.payload;
  },
  setVideoSlug: (state: VideoState, action: PayloadAction<string>) => {
    state.videoSlug = action?.payload;
  },
};

export default VideoReducer;
